import { LuInstagram, LuYoutube } from 'react-icons/lu'

interface PlatformIconProps {
  platform?: string | string[] | null
  className?: string
}

const TikTokIcon = ({ className = 'h-5 w-5' }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.59 6.69C18.6618 6.69266 17.7689 6.32361 17.12 5.67C16.4712 5.01639 16.1022 4.12351 16.1049 3.19529C16.1049 3.12765 16.1049 3.06 16.1049 3H12.8807V16.2723C12.8807 16.6661 12.7922 17.0546 12.6217 17.4077C12.4513 17.7607 12.2033 18.069 11.8965 18.307C11.5897 18.545 11.2322 18.7063 10.8508 18.7783C10.4695 18.8503 10.0747 18.8311 9.70206 18.7224C9.32938 18.6138 8.9878 18.4188 8.70789 18.1541C8.42797 17.8893 8.21698 17.5623 8.09288 17.2004C7.96878 16.8386 7.93523 16.4527 7.99508 16.0751C8.05493 15.6974 8.20647 15.3392 8.43672 15.0317C8.85128 14.5035 9.44572 14.1478 10.0978 14.0358C10.7499 13.9237 11.4199 14.0637 11.9717 14.4269V11.1693C11.5848 11.0659 11.1829 11.0123 10.7798 11.01C9.58694 11.0066 8.43419 11.4403 7.53921 12.2321C6.64423 13.0239 6.06766 14.1234 5.91867 15.3165C5.76969 16.5097 6.05815 17.7154 6.73512 18.715C7.41209 19.7146 8.43135 20.4462 9.60402 20.7783C10.7767 21.1104 12.0293 21.0217 13.1422 20.5288C14.2551 20.0359 15.1588 19.1717 15.699 18.0825C15.919 17.6646 16.0743 17.2161 16.1597 16.7518C16.1698 16.6961 16.1698 16.6392 16.1799 16.5823V10.1549C17.2588 10.8872 18.4983 11.2738 19.76 11.2738H20V8.04C19.8647 8.04 19.7295 8.04 19.59 8.04V6.69Z"
      fill="currentColor"
    />
  </svg>
)

const SinglePlatformIcon = ({ platform, className }: { platform: string; className: string }) => {
  const p = platform.toLowerCase()
  if (p.includes('instagram')) return <LuInstagram className={className} />
  if (p.includes('tiktok')) return <TikTokIcon className={className} />
  if (p.includes('youtube')) return <LuYoutube className={className} />
  return <span className="text-xs">{platform}</span>
}

const PlatformIcon = ({ platform, className = 'h-5 w-5' }: PlatformIconProps) => {
  if (!platform || (Array.isArray(platform) && platform.length === 0)) {
    return <span className="text-xs">—</span>
  }

  const platforms = Array.isArray(platform) ? platform : [platform]

  if (platforms.length === 1) {
    return <SinglePlatformIcon platform={platforms[0]} className={className} />
  }

  return (
    <span className="flex items-center gap-1">
      {platforms.map((p) => (
        <SinglePlatformIcon key={p} platform={p} className={className} />
      ))}
    </span>
  )
}

export default PlatformIcon
